import { Location } from "@/interfaces/location";
import find from "lodash/find";
import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./locationSelect.template.vue";

@Component({
  mixins: [Template]
})
export default class LocationSelectComponent extends Vue {
  @Prop({ required: true }) public value!: Location;
  @Prop({ default: [] }) public items!: Location[];

  public search: string = "";

  public onSelect(location: Location | null) {
    this.$emit("input", location);
  }

  get filteredLocations() {
    if (this.search) {
      return this.items.filter(item =>
        item.name.toLowerCase().includes(this.search.toLowerCase())
      );
    }
    return this.items;
  }

  private created() {
    this.$watch("items", () => {
      if (!this.items.length || !find(this.items, this.value)) {
        this.onSelect(null);
      }
    });
  }
}
